export default __webpack_public_path__ + "static/media/pretty-odd.4027031d.jpg";